import { useAnalytics } from 'app/context/Analytics';
import { useState } from 'react';
import ReactPlayer, { ReactPlayerProps } from 'react-player';

import { PosthogEventName } from '../copied/constants/PosthogEventName';

interface VideoPlayerProps extends ReactPlayerProps {
  video_name?: string;
  title?: string;
}

export default function VideoPlayer({ video_name, title, ...props }: VideoPlayerProps) {
  const { captureEventWithTopicSourceAndActiveScreen: captureEvent } = useAnalytics();
  const [duration, setDuration] = useState(0);

  const onPlay = () => {
    captureEvent(PosthogEventName.VideoPlayed, {
      videoName: video_name,
      topicTitle: title,
      playDuration: duration,
    });
  };

  const onProgress = ({ playedSeconds }: { playedSeconds: number }) => {
    const ms = Number((playedSeconds * 1000).toFixed(0));
    if (ms > 0) {
      setDuration(ms);
      captureEvent(PosthogEventName.VideoProgressed, {
        videoName: video_name,
        topicTitle: title,

        playDuration: ms,
      });
    }
  };

  const onPause = () => {
    captureEvent(PosthogEventName.VideoPaused, {
      videoName: video_name,
      topicTitle: title,
      playDuration: duration,
    });
  };

  const onEnded = () => {
    captureEvent(PosthogEventName.VideoEnded, {
      videoName: video_name,
      topicTitle: title,
      playDuration: duration,
    });
  };

  const callbackProps = {
    onPlay,
    onProgress,
    onPause,
    onEnded,
  };
  return (
    <ReactPlayer
      {...{
        ...callbackProps,
        ...props,
      }}
    />
  );
}
